import {ActionTypes} from '../actions';
import createReducer from '../../common/util/createReducer';

const INITIAL_STATE = {
  'loading': false,
  'loadingDispatch': false,
  'verifying': false,
  'verified': false,
  'createdOrder': '',
  'filename': '',
  'nextDispatchTurn': '',
  'list': [],
  'orderDealer': '',
  'orderAgency': '',
};

export const dealerStockOrders = (state, action) => {
  return createReducer(INITIAL_STATE, {
    [ActionTypes.CLEAR_DEALER_STOCK_ORDER]: (state, action) => (INITIAL_STATE),
    [ActionTypes.CHECK_DEALER_STOCK_ORDER_REQUEST]: (state, action) => ({
      ...state,
      'verifying': true,
    }),
    [ActionTypes.CHECK_DEALER_STOCK_ORDER_SUCCESS]: (state, action) => ({
      ...state,
      'verifying': false,
      'verified': true,
      'list': action.response.data,
      'filename': action.response.filename,
    }),
    [ActionTypes.CHECK_DEALER_STOCK_ORDER_FAILED]: (state, action) => ({
      ...state,
      'verifying': false,
      'verified': false,
      'list': [],
      'filename': '',
    }),
    [ActionTypes.CREATE_DEALER_STOCK_ORDER_REQUEST]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.CREATE_DEALER_STOCK_ORDER_SUCCESS]: (state, action) => ({
      ...state,
      'loading': false,
      'list': action.response.data,
      'createdOrder': action.response.orderCode,
      'orderDealer': action.payload.dealer,
      'orderAgency': action.payload.agency,
    }),
    [ActionTypes.CREATE_DEALER_STOCK_ORDER_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
      'createdOrder': '',
    }),
    [ActionTypes.GET_DEALER_NEXT_DISPATCH_TURN_REQUEST]: (state, action) => ({
      ...state,
      'loadingDispatch': true,
    }),
    [ActionTypes.GET_DEALER_NEXT_DISPATCH_TURN_SUCCESS]: (state, action) => ({
      ...state,
      'loadingDispatch': false,
      'nextDispatchTurn': action.response.data,
    }),
    [ActionTypes.GET_DEALER_NEXT_DISPATCH_TURN_FAILED]: (state, action) => ({
      ...state,
      'loadingDispatch': false,
      'nextDispatchTurn': '',
    }),
  })(state, action);
};
